module.exports = __webpack_public_path__ + "img/hud-01.e5ebfdaf.png";